import { Badge, Dot, type BadgeTone } from '../../../components/ui';
import type { CaixaProvavel, NivelCheck, ResultadoEntrega } from '../entrega';

/**
 * Resultado do teste de entrega: nota, caixa provavel e cada regra com o que
 * fazer. Usado no compositor (enquanto escreve) e no teste de entrega do
 * canal.
 *
 * A nota e a caixa aparecem com texto; o ponto colorido de cada regra vem
 * acompanhado do nivel escrito para quem nao distingue as cores.
 */

const TOM: Readonly<Record<NivelCheck, BadgeTone>> = { ok: 'good', aviso: 'warning', falha: 'critical' };
const ROTULO: Readonly<Record<NivelCheck, string>> = { ok: 'ok', aviso: 'atenção', falha: 'corrigir' };
const CAIXA: Readonly<Record<CaixaProvavel, { readonly rotulo: string; readonly tom: BadgeTone }>> = {
  principal: { rotulo: 'Caixa principal provável', tom: 'good' },
  promocoes: { rotulo: 'Aba Promoções provável', tom: 'warning' },
  spam: { rotulo: 'Risco de spam', tom: 'critical' },
};

export function ChecklistDeEntrega({ resultado, compacto = false }: { readonly resultado: ResultadoEntrega; readonly compacto?: boolean }): JSX.Element {
  const tomNota: BadgeTone = resultado.nota >= 8 ? 'good' : resultado.nota >= 5 ? 'warning' : 'critical';
  const visiveis = compacto ? resultado.checks.filter((c) => c.nivel !== 'ok') : resultado.checks;
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <Badge tone={tomNota} icon="estrela">
          Nota {resultado.nota}/10
        </Badge>
        <Badge tone={CAIXA[resultado.caixa].tom} dot>
          {CAIXA[resultado.caixa].rotulo}
        </Badge>
        <span className="text-xs text-ink-subtle">estimativa por regras; quem decide é o provedor</span>
      </div>
      {visiveis.length === 0 ? (
        <p className="text-sm text-ink-muted">Todas as {resultado.checks.length} regras passaram.</p>
      ) : (
        <ul className="flex flex-col divide-y divide-line/70 rounded-xl border border-line bg-elevated">
          {visiveis.map((c) => (
            <li key={c.chave} className="flex items-start gap-3 px-3 py-2 text-sm">
              <Dot tone={TOM[c.nivel]} className="mt-1.5" />
              <div className="min-w-0 flex-1">
                <p className="text-ink">
                  <span className="font-medium">{c.rotulo}</span> <span className="text-xs text-ink-subtle">· {ROTULO[c.nivel]}</span>
                </p>
                <p className="text-xs text-ink-muted">{c.detalhe}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
